import { render, staticRenderFns } from "./BatchChangePassword.vue?vue&type=template&id=73d7de51"
import script from "./BatchChangePassword.vue?vue&type=script&lang=ts"
export * from "./BatchChangePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports